<template>
	<div class="pasted">
		<van-cell-group > 
			<van-cell title="忌辰：" title-class="van-field__label">
				<template #default>{{pastedInfo.pastdate?pastedInfo.pastdate:pastedInfo.pastday}} {{pastedInfo.hours}}</template>
				<template #right-icon v-if="!readonly"><van-button type="default" plain hairline size="mini" @click.stop="showPopup2PastedTime" :style="{'margin-left':'5px'}">选 / 填</van-button></template>
			</van-cell>

			<van-field
				v-model.trim="pastedInfo.past_place"
				label="过逝地址："
				placeholder="请输入过逝地址"
				:readonly="readonly"
				clearable
			></van-field>
			<van-field
				v-model.trim="pastedInfo.cemetery"
				label="墓塟地址："
				placeholder="请输入墓塟地址"
				:readonly="readonly"
				clearable
			@blur="locationAmapByAddress(pastedInfo.cemetery)"
			></van-field>

			<div id="amap_container_pasted" class="amap_container"></div>

			<van-field
			  v-model.trim="pastedInfo.remark"
			  rows="3"
			  autosize
			  label="备注："
			  type="textarea"
			  maxlength="3000"
			  placeholder="请输入备注内容"
			  show-word-limit
			  :readonly="readonly"
			/>

			<van-row  :style="{'margin-bottom':'10px'}" v-if="!readonly">
				<van-col span="1"></van-col>
				<van-col span="9">
					<van-button type="default" block  @click="showEditPasted=false">取消</van-button>
				</van-col>
				<van-col span="1"></van-col>
				<van-col span="12">
					<van-button type="primary" block  @click="onSavePasted">保存</van-button>
				</van-col>
				<van-col span="1"></van-col>
			</van-row> 

			<van-row  :style="{'margin-bottom':'10px'}" v-if="pastedInfo.id&&!readonly">
				<van-col span="1"></van-col>
				<van-col span="22">
					<van-button type="danger" block  @click="onDelPasted(pastedInfo.id)">清除信息</van-button>
				</van-col>
				<van-col span="1"></van-col>
			</van-row> 

		</van-cell-group>


		<van-popup v-model="showPastedTimePopup" position="bottom" :style="{'min-height':'200px', 'bottom':'50px'}">

			<van-row  :style="{'margin-bottom':'10px'}">
				<van-col span="5">
					<van-sidebar v-model="sidebarActiveKey">
						<van-sidebar-item title="选择日期" />
						<van-sidebar-item title="手动输入" />
					</van-sidebar>
				</van-col>
				<van-col span="19">
					<van-cell-group v-if="sidebarActiveKey==1"> 
						<van-field
							v-model.trim="pastedInfo.pastdate"
							label=""
							placeholder="请输入"
							clearable
						
						></van-field>
					</van-cell-group > 
					<van-cell-group v-if="sidebarActiveKey==0"> 
						<van-cell
							title="时间："
							is-link
							:value="pastedInfo.pastday"
							title-class="van-cell-title"
							@click="showPastedTimePicker=1"
						>
							<template #right-icon>
								<van-icon name="arrow" class="van-cell__right-icon" />
								<van-button type="default" plain hairline size="mini" @click.stop="pastedInfo.pastday=''" :style="{'margin-left':'5px'}">置空</van-button>
							</template>
						</van-cell>
						<van-cell
							title="日历："
							title-class="van-cell-title"
						>
							<template #default>
								<van-radio-group v-model="pastedInfo.calendar" direction="horizontal">
									<van-radio name="L">阴历</van-radio>
									<van-radio name="S">阳历</van-radio>
								</van-radio-group>
							</template>
						</van-cell>


						<van-cell
							@click="showPickers(2)"
							title="时辰："
							is-link
							:value="pastedInfo.hours"
							title-class="van-cell-title"
						>
						</van-cell>

						<van-cell
							@click="showPickers(1)"
							title="闰月："
							is-link
							:value="shifouArr[pastedInfo.leep_month]"
							title-class="van-cell-title"
						>
						</van-cell>
					</van-cell-group > 
				</van-col>
			</van-row> 
			<van-row  :style="{'margin-bottom':'10px'}" v-if="sidebarActiveKey==0&&showPastedTimePicker>0">
				<van-col span="24">
					<van-cell-group>
						<van-datetime-picker
							type="datetime"
							title="时间"
							:min-date="new Date(1900, 0, 1)"
							:max-date="new Date()"
							
							@confirm="onConfirmPastedTime"
							@cancel="showPastedTimePicker=0"
						/>
					</van-cell-group > 
				</van-col>
			</van-row> 
			<van-row  :style="{'margin-bottom':'10px'}">
				<van-col span="1"></van-col>
				<van-col span="22">
					<van-button type="primary" block  @click="showPastedTimePopup=false" :disabled="sidebarActiveKey==0&&showPastedTimePicker>0">确定</van-button>
				</van-col>
				<van-col span="1"></van-col>
			</van-row> 
			
		</van-popup>

		<van-popup v-model="showPicker" position="bottom">
		  <van-picker
			show-toolbar
			title="请选择"
			:columns="pickerColumns"
			@cancel="showPicker = false"
			@confirm="onConfirmPicker"
		  />
		</van-popup>

	</div>
</template>

<script>
import { Sidebar, SidebarItem, DatetimePicker } from "vant";

export default {
	name: "clans_pasted",
	components: {
		"van-sidebar":Sidebar,
		"van-sidebar-item":SidebarItem,
		"van-datetime-picker":DatetimePicker
	},
	props:{
		scsx:Object,
		p_id:Number,
		readonly:Boolean
	},
	data() {
		return {
			title: "过往信息管理",
			u_id: localStorage.getItem("u_id"),
			token: localStorage.getItem(localStorage.getItem("u_id") + "token"),
			shifouArr:['否','是'],

			pastedInfo:{},
			preCemetery:'',
			showPastedTimePopup:false,
			sidebarActiveKey:0,
			showPastedTimePicker:0,
			
			amap:null,
			amapGeocoder:{},
			amapMarker:false,
			saveFlag:false,

			showPickerType:-1,
			showPicker:false,
			pickerColumns:[]
		};
	},
	created() {
		let that = this;
		if(this.amap==null){
			this.$nextTick(() => {
				that.amap = new AMap.Map("amap_container_pasted", {
					resizeEnable: true
				});
				if(!that.readonly){
					that.amap.on('click', function(e) {
						that.markerAmap([e.lnglat.getLng(), e.lnglat.getLat()],1);
					});
				}
				that.amapGeocoder = new AMap.Geocoder({
					city:''//cityad
				});
				
			});
		}

		this.getPastedData();
		
	},
	computed: {
		scsxCols:function(){
			let sc = [];
			let sx = [];
			let cols = [];
			let obj = null;
			for(var k in this.scsx){
				obj = this.scsx[k];
				sc.push(obj.sc);
				sx.push(obj.sx);
				obj['key'] = k;
				cols.push(obj);
			}
			return {sc:sc, sx:sx, cols:cols}
		}
	},
	methods: {
		initAmapByCity(cityad){
			this.locationAmapByAddress(cityad)
		},
		markerAmap(lnglat, reset){
			if(this.amapMarker){
				this.amap.remove(this.amapMarker);
			}
			this.amapMarker = new AMap.Marker();
			this.amapMarker.setPosition(lnglat);
			this.amap.add(this.amapMarker);
			this.amap.setFitView(this.amapMarker);
			this.pastedInfo['lnglat'] = lnglat[0] + ',' + lnglat[1];
			if(reset){
				this.resetAddressByLnglat(lnglat);
			}
		},
		resetAddressByLnglat(lnglat){
			var geocoder = new AMap.Geocoder({
				city: ''
			})
			let that = this;
			geocoder.getAddress(lnglat, function (status, data) {
				if (status === 'complete' && data.info === 'OK') {
					// result为对应的地理位置详细信息
					//console.log(data)
					let faddress = data.regeocode.formattedAddress;
					let acomp = data.regeocode.addressComponent;
					let district = acomp.district;
					let fadr = faddress.split(district);
					that.$delete(fadr, 0);
					that.pastedInfo.cemetery = fadr.join(district);
					that.$forceUpdate();
				}
			})

		},
		locationAmapByAddress(ads){
			if(ads && this.preCemetery != ads){
				let that = this;
				this.amapGeocoder.getLocation(ads, function(status, result) {
					if (status === 'complete'&&result.geocodes.length) {
						let local = result.geocodes[0].location;
						that.markerAmap([local.lng, local.lat],0);
					}else{
						that.$toast.fail("地址定位失败，请手动指定");
					}
				});
			}
		},
		getPastedData(){
			var params = {
				u_id:this.u_id,
				token:this.token,
				p_id:this.p_id,
			};
			let that = this;
			var url = this.Conf.serverUrl + "clans/personalPasted" + "?num="+Math.random();
			this.$axios
			.post(url, this.$qs.stringify(params))
			.then(response => {
				that.pastedInfo = {p_id:that.p_id,calendar:'L'};
				if(response.data.data){
					that.pastedInfo = response.data.data;
					that.preCemetery = that.pastedInfo.cemetery;
					if(that.pastedInfo.lnglat){
						setTimeout(() => {
							that.markerAmap(that.pastedInfo.lnglat.split(","),0);
						},1000);
					}
				}
			})
			.catch(error => {});
		},
		showPickers(t){
			this.showPickerType = t;
			if(t ==1){
				this.pickerColumns = this.shifouArr;
			}
			if(t==2){
				this.pickerColumns = this.scsxCols.sc;
			}
			this.showPicker = true;
		},
		onConfirmPicker(value, indexs){
			if(this.showPickerType==1){
				this.pastedInfo.leep_month = indexs;
			}
			if(this.showPickerType==2){
				this.pastedInfo.hours = value;
				if(this.pastedInfo.pastday){
					this.pastedInfo.pastday = this.pastedInfo.pastday.split(" ")[0] + " " + this.scsxCols.cols[indexs].sj + ":00";
				}
			}
			this.showPicker = false;
		},
		showPopup2PastedTime(){
			this.showPastedTimePopup = true;
			this.sidebarActiveKey = this.pastedInfo.pastdate?1:0;
		},
		onDelPasted(id){
			this.$dialog
			.confirm({
				title: "温馨提醒",
				message: "删除后将不可恢复，确定？",
			})
			.then(() => {
				var params = {
					u_id:this.u_id,
					token:this.token,
					id:id
				};
				let that = this;
				var url = this.Conf.serverUrl + "clans/personalPastedDel" + "?num="+Math.random();
				this.$axios
				.post(url, this.$qs.stringify(params))
				.then(response => {
					that.$toast.success(response.data.msg);
					if(response.data.code == 200){
						that.$emit("callAfterSave",'delete');
						that.pastedInfo = {p_id:that.p_id,calendar:'L'};
					}
				})
				.catch(error => {});
			})
			.catch((error) => {});
		},
		onSavePasted(){
			if(this.saveFlag){
				this.$toast.fail("请求尚未响应，请勿重复提交！");
				return false;
			}
			this.saveFlag = true;
			var params = {
				u_id:this.u_id,
				token:this.token,
				data:this.pastedInfo
			};
			let that = this;
			var url = this.Conf.serverUrl + "clans/personalPastedSave" + "?num="+Math.random();
			this.$axios
			.post(url, this.$qs.stringify(params))
			.then(response => {
				that.saveFlag = false;
				that.showPastedTimePopup = false;
				that.showEditPasted = false;
				that.$toast.success(response.data.msg);
				if(response.data.code == 200){
					that.$emit("callAfterSave",'save');
					that.getPastedData();
				}
			})
			.catch(error => {});
		},
		onConfirmPastedTime(val){
			if(this.showPastedTimePicker==1){
				this.pastedInfo.pastday = this.$options.filters['moment_format'](val.getTime(),'YYYY-MM-DD HH:mm:00');
				let hrs = parseInt(this.$options.filters['moment_format'](val.getTime(),'HH'));
				switch(hrs){
					case 1:
					case 2:
						this.pastedInfo.hours = this.scsx['CHOU'].sc;
						break;
					case 3:
					case 4:
						this.pastedInfo.hours = this.scsx['YIN'].sc;
						break;
					case 5:
					case 6:
						this.pastedInfo.hours = this.scsx['MAO'].sc;
						break;
					case 7:
					case 8:
						this.pastedInfo.hours = this.scsx['CHEN'].sc;
						break;
					case 9:
					case 10:
						this.pastedInfo.hours = this.scsx['SI'].sc;
						break;
					case 11:
					case 12:
						this.pastedInfo.hours = this.scsx['WU'].sc;
						break;
					case 13:
					case 14:
						this.pastedInfo.hours = this.scsx['WEI'].sc;
						break;
					case 15:
					case 16:
						this.pastedInfo.hours = this.scsx['SHEN'].sc;
						break;
					case 17:
					case 18:
						this.pastedInfo.hours = this.scsx['YOU'].sc;
						break;
					case 19:
					case 20:
						this.pastedInfo.hours = this.scsx['XU'].sc;
						break;
					case 21:
					case 22:
						this.pastedInfo.hours = this.scsx['HAI'].sc;
						break;
					default:
						this.pastedInfo.hours = this.scsx['ZI'].sc;
						break;
				}
			}
			this.showPastedTimePicker=0;
			this.$forceUpdate();
		}
	},
	watch:{
		sidebarActiveKey(n,o){
			if(n){
				this.pastedInfo.pastday = '';
				this.pastedInfo.hours = '';
			}else{
				this.pastedInfo.pastdate = '';
			}
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/Clans/PastedInfo.vue